import { QueryKey } from '@tanstack/react-query';
import createKeyFactory, { FactoryQueryParams, KEYS } from 'utils/createKeyFactory';

const cardsFactory = {
  ...createKeyFactory([KEYS.CARDS]),
  statsList: (params?: FactoryQueryParams) => [...cardsFactory.all(), KEYS.CARDS_STATS, ...cardsFactory.list(params)],
  statsDetails: (id?: string | null): QueryKey => [
    ...cardsFactory.all(),
    KEYS.CARDS_STATS,
    KEYS.DETAILS,
    ...(id ? [id] : []),
  ],
  variants: (id?: string | null): QueryKey => [...cardsFactory.all(), KEYS.CARDS_VARIANTS, ...(id ? [id] : [])],
  cardHistories: (cardRef: string | null): QueryKey => [...cardsFactory.all(), KEYS.CARDS_HISTORIES, cardRef],
};

export const cardsFilterDataFactory = createKeyFactory([KEYS.CARDS_FILTER_DATA]);

export default cardsFactory;
